import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from 'vue-i18n-composable'
import { Icons } from '@/icons/icons'
import { externalURLS } from '@/router/routes/urlRoutes'

// TRANSLATIONS

export default /*#__PURE__*/_defineComponent({
  __name: 'ContactUsCardComponent',
  setup(__props) {

const { t } = useI18n()
const text = {
  email: t('components.dialog.support_service.contact_us.email'),
  phones: t('components.dialog.support_service.contact_us.phones'),
  timetable: t('components.dialog.support_service.contact_us.timetable'),
  title: t('components.dialog.support_service.contact_us.title')
}

// DATA
const icon = {
  email: Icons.EMAIL,
  phone: Icons.CALL
}
const emaiURL = externalURLS.help_center_email

return { __sfc: true,t, text, icon, emaiURL }
}

})